import store from "@/store";
import { ApiWrapper } from "../types/main";
import { ScheduledReport, ScheduledReportData, ScheduledReportTemplate } from "../types/scheduledReport";
import { apiCall, http } from "./http";
interface UploadFileParams {
    file: File;
    projectId: string;
    activationId?: number;
}
function base64ToUtf8(base64) {
    const binaryString = atob(base64);
    const bytes = Uint8Array.from(binaryString, (c) => c.charCodeAt(0));
    const decoder = new TextDecoder("utf-8");
    return decoder.decode(bytes);
}
export async function uploadMedia({ projectId, file }: UploadFileParams) {
    const url = `file/media`;
    const formData = new FormData();
    formData.append("projectId", projectId);
    formData.append("file", file, file.name);
    const res = apiCall<{ url: string }>(() => http.post(url.toString(), { body: formData }));
    return res;
}
export async function uploadExcel({ projectId, file, activationId }: UploadFileParams) {
    const url = `excel/upload`;
    const formData = new FormData();
    formData.append("projectId", projectId);
    formData.append("file", file, file.name);
    formData.append("activationId", activationId.toString());
    const res = apiCall<any>(() => http.post(url.toString(), { body: formData }));
    return res;
}
export async function exportActivations({ projectId, activations, exportMessageVars }:
    {
        projectId: string,
        activations: Array<{name: string, id: number}>,
        exportMessageVars: boolean,
    },
) {
    const url = `excel/exportActivations`;
    try {
        const res = await http.post(url.toString(), { json: { projectId, activations, exportMessageVars } });
        if (res.ok) {
            const blob = await res.blob();
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            const now = new Date();
            const pad = (n) => n.toString().padStart(2, "0");
            const formatted = `${pad(now.getDate())}.${pad(now.getMonth() + 1)}.${now.getFullYear()}`;
            link.download = `export_${projectId}_${formatted}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(link.href);
        } else {
            store.dispatch("callNotify", "Ошибка экспорта");
        }
    } catch (error) {
        console.error(error);
        store.dispatch("callNotify", "Ошибка экспорта");
    }
}
export async function importActivations({ projectId, file}: UploadFileParams) {
    const url = `excel/importActivations`;
    const formData = new FormData();
    formData.append("projectId", projectId);
    formData.append("file", file, file.name);
    let response;
    let headerData;
    let results;
    try {
        response = await http.post(url.toString(), { body: formData });
        const base64 = response.headers.get("X-JSON-Data");
        if (base64) {
            const jsonString = base64ToUtf8(base64);
            headerData = JSON.parse(jsonString);
        }
        if (response.ok) {
            if (headerData) {
                const blob = await response.blob();
                const link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                const now = new Date();
                const pad = (n) => n.toString().padStart(2, "0");
                const formatted = `${pad(now.getDate())}.${pad(now.getMonth() + 1)}.${now.getFullYear()}`;
                link.download = `backup_${projectId}_${formatted}.xlsx`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(link.href);
                results = headerData;
            }
        } else {
            results = await response.json();
        }
    } catch (error) {
        console.error(error);
    }
    return results;
}
